module.exports = __webpack_public_path__ + "img/cards-tab-4.d7a157ec.png";